




































import Vue, { PropType } from "vue";
import { Component } from "vue-property-decorator";
import { RecommendationExtra } from "../store/model";

const SavingsCostCellProps = Vue.extend({
  props: {
    rowRecommendation: {
      type: Object as PropType<RecommendationExtra>,
      required: true
    }
  }
});

@Component
export default class SavingsCostCell extends SavingsCostCellProps {
  get cost(): number {
    return this.rowRecommendation.costCol;
  }
  get costRounded(): string {
    return this.cost.toFixed(2);
  }
  get costColour(): string {
    return this.cost > 0 ? "orange" : "green";
  }
}
